<style lang="less">
</style>
<template>
  <div>
    <Drawer
      :closable="false"
      placement="right"
      v-model="drawerVisible"
      width="50%"
      :title="drawerTitle"
    >
      <Row>
        <Col>
          <Card :shadow="false">
            <Row>
              <Form
                ref="form"
                :model="form"
                :label-width="110"
                :rules="formValidate"
                style="position: relative"
              >
                  <FormItem
                      label="企业名称"
                      prop="groupId"
                  >
                    <el-button @click="actData.groupChosen.ifShow = true"
                    >{{ actData.groupName || "请选择部门" }}
                    </el-button>
                    <el-dialog
                        width="40%"
                        title="选择部门"
                        :visible.sync="actData.groupChosen.ifShow"
                        append-to-body
                    >
                      双击确认选择部门
                      <el-tree
                          :data="departmentGroupTree"
                          :props="{ label: 'groupName' }"
                          @node-click="actTreeClick"
                      ></el-tree>
                    </el-dialog>
                </FormItem>

                <FormItem label="联系人" prop="linkMan">
                  <Input v-model="form.linkMan" />
                </FormItem>
                <FormItem label="联系电话" prop="compTel">
                  <Input v-model="form.compTel" :disabled="type == 1" />
                </FormItem>
                <FormItem label="联系地址" prop="address">
                  <Input v-model="form.address" />
                </FormItem>
                <FormItem label="会员截止日期" prop="expiryDate">
                  <DatePicker
                    @on-change="dataChange"
                    :value="form.expiryDate"
                    format="yyyy-MM-dd"
                    placeholder="请选择会员截止日期"
                    style="width: 200px"
                  ></DatePicker>
                </FormItem>
                <FormItem label="联系邮箱" prop="compEmail">
                  <Input v-model="form.compEmail" />
                </FormItem>
                <FormItem label="员工数量" prop="staffNum">
                  <Input v-model="form.staffNum" />
                </FormItem>
                <FormItem label="企业logo" prop="compLogo">
                  <upload-input
                    :fileUrl="form.compLogo"
                    fileSize="200"
                    @on-change="handleUpload"
                    width="400px"
                    ref="upload"
                  ></upload-input>
                </FormItem>
                <FormItem label="企业简介" prop="companyContent" v-if="false">
                  <div ref="editor"></div>
                </FormItem>
                <FormItem label="默认密码">
                  <Input v-model="password" :disabled="true" />
                </FormItem>

                <Form-item class="br">
                  <Button
                    type="primary"
                    :loading="submitLoading"
                    @click="handelSubmit"
                    style="width: 100px"
                    >提交</Button
                  >
                  <Button @click="handelCancel">取消</Button>
                </Form-item>
                <Spin size="large" fix v-if="loading"></Spin>
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- html编辑 -->
      <Modal
        title="编辑html代码"
        v-model="showHTMLModal"
        :mask-closable="false"
        :width="900"
        :fullscreen="full"
      >
        <Input
          v-if="!full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
          style="max-height: 60vh; overflow: auto"
        />
        <Input
          v-if="full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
        />
        <div slot="footer">
          <Button @click="full = !full" icon="md-expand">全屏开/关</Button>
          <Button
            @click="editHTMLOk"
            type="primary"
            icon="md-checkmark-circle-outline"
            >确定保存</Button
          >
        </div>
      </Modal>
      <Modal title="预览" v-model="fullscreenModal" fullscreen>
        <div v-html="form.courseContent">{{ form.courseContent }}</div>
        <div slot="footer">
          <Button @click="fullscreenModal = false">关闭</Button>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>
<script>
import { uploadFile, addCompany, editCompany, getCompany ,searchDepartmentGroup} from "@/api/index";
import uploadInput from "@/views/my-components/flyme/upload-input";
import E from "wangeditor";
// 表情包配置 自定义表情可在该js文件中统一修改
import { sina } from "@/libs/emoji";

let editor = null;
var xss = require("xss");
export default {
  name: "company-drawer",
  components: {
    uploadInput,
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      var reg = /^[1][3,4,5,6,7,8][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      departmentGroupTree: [],
      type: 0,
      loading: false, // 表单加载状态
      selectUsers: [],
      drawerTitle: "添加课程",
      drawerVisible: false,
      password: "手机号后6位",
      form: {
        compName: "",
        compTel: "",
        avatar: "",
        expiryDate: "",
        address: "",
        compLogo: "",
        linkMan: "",
        companyContent: "",
        compEmail: "",
        staffNum: 1,
       ifShow:false,
      },
      formValidate: {
        compName: [
          { required: true, message: "企业名称不能为空", trigger: "blur" },
        ],
        linkMan: [
          { required: true, message: "联系人不能为空", trigger: "blur" },
        ],
        expiryDate: [
          { required: true, message: "截至日期不能为空", trigger: "blur" },
        ],
        compTel: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        compEmail: [
          { required: false, message: "请输入邮箱地址" },
          { type: "email", message: "邮箱格式不正确" },
        ],
      },
      submitLoading: false, // 添加或编辑提交状态
      dataEdit: "", // 编辑数据
      showHTMLModal: false, // 显示html
      full: false, // html全屏开关
      fullscreenModal: false, // 显示全屏预览
      actData: {
        ifShow: false,
        title: "",
        remark: "",
        userList: [],
        roleId: 0,
        groupId: 0,
        groupName: "",
        groupChosen: { item: {}, count: 0, timeOut: {}, ifShow: false },
      },
    };
  },
  methods: {
    init() {
      this.initEditor();
    },
    showDrawer(params) {
      console.log("waooooo",params)
      if (params.id) {
        this.type = 1;
        this.drawerTitle = "编辑企业";
        this.form.id = params.id;
        this.getData();
      } else {
        this.$refs.form.resetFields();
        this.$refs.upload.setPicUrl("");
        this.drawerTitle = "添加企业";
        this.type = 0;
      }
      this.drawerVisible = true;
      this.actData.groupName = params.groupName;
    },
    initEditor() {
      let that = this;
      editor = new E(this.$refs.editor);
      let editorConfig = editor.customConfig
        ? editor.customConfig
        : editor.config;
      editorConfig.onchange = (html) => {
        this.form.companyContent = html;
      };
      editorConfig.uploadImgServer = uploadFile;
      editorConfig.uploadImgHeaders = {
        Authorization: that.getStore("accessToken"),
      };
      editorConfig.uploadFileName = "file";
      editorConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {},
        success: function (xhr, editor, result) {},
        fail: function (xhr, editor, result) {
          that.$Message.error("上传图片失败");
        },
        error: function (xhr, editor) {
          that.$Message.error("上传图片出错");
        },
        timeout: function (xhr, editor) {
          that.$Message.error("上传图片超时");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.status === true) {
            let url = result.data.fileUrl;
            insertImg(url);
            that.$Message.success("上传图片成功");
          } else {
            that.$Message.error(result.info);
          }
        },
      };
      editorConfig.fontNames = ["微软雅黑", "宋体", "黑体", "Arial"];
      editorConfig.emotions = [
        {
          title: "新浪",
          type: "image",
          content: sina,
        },
      ];
      editor.create();
    },
    editHTML() {
      this.dataEdit = this.form.companyContent;
      this.showHTMLModal = true;
    },
    editHTMLOk() {
      editor.txt.html(this.dataEdit);
      this.form.content = xss(this.dataEdit);
      this.showHTMLModal = false;
    },
    dataChange(data1, data2) {
      this.form.expiryDate = data1;
    },
    pageInit() {
      searchDepartmentGroup().then((data) => {
        console.log("eeeee",data);
        this.departmentGroupTree = data;

      });


    },
    getData() {
      this.loading = true;
      getCompany(this.form.id).then((res) => {
        this.loading = false;
        if (res.status === true) {
          this.form = res.data;
          if (res.data.companyContent == "<p><br></p>") {
            this.form.companyContent = "";
          }
          editor.txt.html(this.form.companyContent);
          this.$refs.upload.setPicUrl(this.form.compLogo);
        }
      });
    },
    handelSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.staffNum < 1) {
            this.$Message.error("员工人数不能小于1");
            return false;
          }
          this.submitLoading = true;
          if (this.type === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
           // delete this.form.id;
            this.form.id =  this.actData.groupId
            addCompany(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.getDataList();
                this.drawerVisible = false;
              }
            });
          } else if (this.type === 1) {
            // 编辑
            if (!this.form.compLogo) {
              this.form.compLogo = "https://s1.ax1x.com/2018/05/19/CcdVQP.png";
            }
            editCompany(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.getDataList();
                this.drawerVisible = false;
              }
            });
          }
        }
      });
    },
    actDialogSubmit() {
      switch (this.actData.type) {
        case "group":
          if (this.staffData.ifShow) {
            //     // this.staffData.groupId = this.actData.groupId;
            //     // this.staffData.groupName = this.actData.groupName;
            //     this.$set(this.staffData, "groupId", this.actData.groupId);
            //     this.$set(this.staffData, "groupName", this.actData.groupName);
            //     this.actData.ifShow = false;
            this.actData.ifShow = false;
          } else {
            // let postData = {};
            // Object.assign(postData, this.actData);
            // postData.groupId = this.actData.groupId;
            // postData.groupName = this.actData.groupName;
            editUsersGroup({
              userIds: this.actData.userList.map((item) => item.id),
              departmentGroupId: this.actData.groupId,
            }).then((data) => {
              this.$message.success(data.info);
              this.actData.ifShow = false;
              this.getData();
            });
          }
          break;
        default:
          break;
      }
    },
    actTreeClick(item) {
      if (this.actData.groupChosen.item.id == item.id) {
        this.actData.groupChosen.count++;
      } else {
        this.actData.groupChosen.item = item;
        this.actData.groupChosen.count = 1;
      }
      clearTimeout(this.actData.groupChosen.timeOut);
      this.actData.groupChosen.timeOut = setTimeout(() => {
        if (this.actData.groupChosen.count >= 2) {
          this.actData.groupId = this.actData.groupChosen.item.id;
          this.actData.groupName = this.actData.groupChosen.item.groupName;
          this.form.compName = this.actData.groupChosen.item.groupName;
          if (this.form.ifShow) {
            this.form.groupId = this.actData.groupChosen.item.id;
            this.form.groupName = this.actData.groupChosen.item.groupName;
          }

          this.$set(this.actData.groupChosen, "ifShow", false);
        }
        this.actData.groupChosen.count = 0;
      }, 300);
    },
    handelCancel() {
      this.drawerVisible = false;
    },
    handleUpload(v) {
      this.form.compLogo = v.fileUrl;
    },
  },
  mounted() {
    this.pageInit();
  },
  watch: {},
};
</script>